import {Room, RoomAPIInterface, RoomInterface} from "@/entity/Room";
import {UserAPIInterface, UserInterface} from "@/entity/User";
import moment from "moment";

export interface ReservationAPIGlobalInterface {
  [index: string]: any,

  "@context": string;
  "@id": string;
  "@type": string;
  "hydra:member": ReservationAPIInterface[];
  "hydra:search": any;
  "hydra:totalItems": number;
  "hydra:view": any;
}

export interface ReservationAPIInterface {
  [index: string]: any,

  "@context": string | undefined;
  "@id": string;
  "@type": string;
  id: number;
  status: number;
  startDate: string;
  endDate: string;
  name: string;
  room: RoomAPIInterface | string;
  owner: UserAPIInterface | string;
  recurrenceGroupId: string | null;
}

export interface ReservationInterface {
  [index: string]: any,

  id: number | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  name: string | undefined;
  status: number | undefined;
  room: RoomInterface | string | undefined;
  recurrenceGroupId: string | null | undefined;
  log: string | undefined;
  owner: UserInterface | string | undefined;
}

export class Reservation {
  [index: string]: any;

  public id: number | undefined;
  public startDate: Date | undefined;
  public endDate: Date | undefined;
  public name: string | undefined;
  public status: number | undefined;
  public room: RoomInterface | string | undefined;
  public recurrenceGroupId: string | null | undefined;
  public log: string | undefined;
  public owner: UserInterface | string | undefined;

  constructor(reservation: ReservationInterface | undefined = undefined) {
    this.id = reservation?.id ? reservation.id : undefined;
    this.startDate = reservation?.startDate ? reservation.startDate : undefined;
    this.endDate = reservation?.endDate ? reservation.endDate : undefined;
    this.name = reservation?.name ? reservation.name : undefined;
    this.status = reservation?.status ? reservation.status : undefined;
    this.room = reservation?.room ? reservation.room : undefined;
    this.recurrenceGroupId = reservation?.recurrenceGroupId ? reservation.recurrenceGroupId : undefined;
    this.log = reservation?.log ? reservation.log : undefined;
    this.owner = reservation?.owner ? reservation.owner : undefined;
  }

  public removeOwner() {
    this.owner = undefined;
  }

  public convertStartAndEndDateForDataBase() {
    const startDate = moment(this.startDate);
    startDate.add(startDate.utcOffset(), 'm').utc();
    this.startDate = startDate.toDate();

    const endDate = moment(this.endDate);
    endDate.add(endDate.utcOffset(), 'm').utc()
    this.endDate = endDate.toDate();
  }
}


// Endpoint api/reservations/available/2020-08-24/+02:00
export interface ExistingDayReservation {
  [index: string]: any;

  id: number;
  startDate: Date,
  endDate: Date,
}
